















































import useTemplates from "@/composables/v3/useTemplates";
import { useUploadAttachmentsStore } from "@/store/useUploadAttachmentsStore";
import { getFullPath } from "@/utils/assets";
import { resolveContentTypeIcon } from "@/utils/chats";
import { UploadDto } from "@saysimple-platform/dtos";
import { defineComponent } from "@vue/composition-api";
import { BButton, BSpinner, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const attachmentsStore = useUploadAttachmentsStore();
        const { selectedTemplate, hasMediaTemplateFilesUploaded } = useTemplates();

        const getSrc = (file): string => {
            if (file.originalFileObject) {
                return URL.createObjectURL(file.originalFileObject);
            }

            return getFullPath(file);
        };

        const removeAttachment = (attachment: UploadDto) => {
            attachmentsStore.removeAttachment(attachment);

            if (selectedTemplate.value.mediaType) {
                hasMediaTemplateFilesUploaded.value = false;
            }
        };

        return {
            removeAttachment,
            selectedTemplate,
            attachmentsStore,
            resolveContentTypeIcon,
            getSrc,
        };
    },
});
